module.exports = __webpack_public_path__ + "img/login-img2.c638f924.png";